export enum ReportGeneratorStatus {
    InProgress = 'InProgress',
    Completed = 'Completed',
    Failed = 'Failed',
    Published = 'Published',
    Deleted = 'Deleted',
    InDraft = 'InDraft',
    SentForPublishing = 'SentForPublishing',
}
